module.exports = __webpack_public_path__ + "img/zerp-tracker.3ae7e0e3.png";